import { render, staticRenderFns } from "./checkout-confirm-action.vue?vue&type=template&id=1ee38120&"
import script from "./checkout-confirm-action.vue?vue&type=script&lang=js&"
export * from "./checkout-confirm-action.vue?vue&type=script&lang=js&"
import style0 from "./checkout-confirm-action.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports